import { Bot } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Button } from '@/components/common/Button';
import { CHESS_BOT_PATH } from '@/lib/chess/pratica';

/**
 * LA TESSERA «Gioca contro il bot» della Hub degli scacchi (E7 di ADR-0193): una scheda con la frase e un solo bottone che porta
 * a `/chess/bot` (la scelta di Elo, orologio e colore). Montata da `chessSectionDefs` SOLO col flag del bot (`sections.ts`): senza,
 * ne' la scheda ne' questo componente sono nel bundle di produzione. Il ruolo `beta` lo chiede chi monta la Hub (`showChess`).
 */
export function ChessBotPanel() {
  const { t } = useTranslation('chessBot');
  const navigate = useNavigate();
  return (
    <div data-bot-tessera="" className="flex flex-col gap-3 pb-6 pt-4">
      <div className="flex flex-col gap-3 rounded-2xl bg-bg-secondary p-4">
        <div className="flex items-center gap-2 text-fg">
          <Bot className="h-5 w-5 text-brand" aria-hidden />
          <h2 className="text-base font-semibold">{t('tile.title')}</h2>
        </div>
        <p className="text-sm text-fg-muted">{t('tile.text')}</p>
        <Button fullWidth onClick={() => navigate(CHESS_BOT_PATH)}>
          {t('tile.cta')}
        </Button>
      </div>
    </div>
  );
}
